import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CustomersList } from "@/features/admin/customers/list";
import {
  filterSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  search: z.string().optional(),
  filters: z
    .object({
      type: withOperators(z.string().optional()),
      status: withOperators(z.string().optional()),
      planKey: withOperators(z.string().optional()),
      // Accepts the empty-shell "" (chip added before a value is picked) plus
      // the canonical "true"/"false" the boolean widget writes.
      requiredCompleteCheckout: withOperators(
        z
          .union([
            z.literal("true"),
            z.literal("false"),
            z.literal(""),
            z.boolean(),
          ])
          .optional(),
      ),
      hasReferId: withOperators(
        z
          .union([
            z.literal("true"),
            z.literal("false"),
            z.literal(""),
            z.boolean(),
          ])
          .optional(),
      ),
    })
    .optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/customers/")({
  validateSearch: searchSchema,
  component: CustomersList,
});
